var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "report-page" },
    [
      _vm._m(0),
      _c(
        "el-card",
        {
          staticClass: "filter-card",
          attrs: {
            shadow: "never",
            "body-style": { padding: "18px 22px 8px" },
          },
        },
        [
          _c(
            "el-form",
            {
              attrs: { inline: "", size: "small" },
              nativeOn: {
                submit: function ($event) {
                  $event.preventDefault()
                },
              },
            },
            [
              _c(
                "el-form-item",
                { attrs: { label: "内容搜索" } },
                [
                  _c("el-input", {
                    staticClass: "keyword",
                    attrs: { clearable: "", placeholder: "标题 / 内容" },
                    nativeOn: {
                      keyup: function ($event) {
                        if (
                          !$event.type.indexOf("key") &&
                          _vm._k(
                            $event.keyCode,
                            "enter",
                            13,
                            $event.key,
                            "Enter"
                          )
                        ) {
                          return null
                        }
                        return _vm.handleSearch($event)
                      },
                    },
                    model: {
                      value: _vm.searchForm.keywords,
                      callback: function ($$v) {
                        _vm.$set(
                          _vm.searchForm,
                          "keywords",
                          typeof $$v === "string" ? $$v.trim() : $$v
                        )
                      },
                      expression: "searchForm.keywords",
                    },
                  }),
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: "工地项目" } },
                [
                  _c(
                    "el-select",
                    {
                      attrs: {
                        clearable: "",
                        filterable: "",
                        placeholder: "全部项目",
                      },
                      on: { change: _vm.handleSearch },
                      model: {
                        value: _vm.searchForm.projectId,
                        callback: function ($$v) {
                          _vm.$set(_vm.searchForm, "projectId", $$v)
                        },
                        expression: "searchForm.projectId",
                      },
                    },
                    _vm._l(_vm.projectOptions, function (item) {
                      return _c("el-option", {
                        key: item.id,
                        attrs: { label: item.name, value: item.id },
                      })
                    }),
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: "汇报类型" } },
                [
                  _c(
                    "el-select",
                    {
                      attrs: { clearable: "", placeholder: "全部类型" },
                      on: { change: _vm.handleSearch },
                      model: {
                        value: _vm.searchForm.reportType,
                        callback: function ($$v) {
                          _vm.$set(_vm.searchForm, "reportType", $$v)
                        },
                        expression: "searchForm.reportType",
                      },
                    },
                    _vm._l(_vm.typeOptions, function (item) {
                      return _c("el-option", {
                        key: item.value,
                        attrs: { label: item.label, value: item.value },
                      })
                    }),
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: "发布状态" } },
                [
                  _c(
                    "el-select",
                    {
                      attrs: { clearable: "", placeholder: "全部状态" },
                      on: { change: _vm.handleSearch },
                      model: {
                        value: _vm.searchForm.status,
                        callback: function ($$v) {
                          _vm.$set(_vm.searchForm, "status", $$v)
                        },
                        expression: "searchForm.status",
                      },
                    },
                    [
                      _c("el-option", {
                        attrs: { label: "草稿", value: "draft" },
                      }),
                      _c("el-option", {
                        attrs: { label: "已发布", value: "published" },
                      }),
                      _c("el-option", {
                        attrs: { label: "已屏蔽", value: "hidden" },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: "可见范围" } },
                [
                  _c(
                    "el-select",
                    {
                      attrs: { clearable: "", placeholder: "全部范围" },
                      on: { change: _vm.handleSearch },
                      model: {
                        value: _vm.searchForm.visibility,
                        callback: function ($$v) {
                          _vm.$set(_vm.searchForm, "visibility", $$v)
                        },
                        expression: "searchForm.visibility",
                      },
                    },
                    [
                      _c("el-option", {
                        attrs: { label: "内部可见", value: "internal" },
                      }),
                      _c("el-option", {
                        attrs: { label: "项目可见", value: "project" },
                      }),
                      _c("el-option", {
                        attrs: { label: "公开展示", value: "public" },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: "汇报日期" } },
                [
                  _c("el-date-picker", {
                    attrs: {
                      type: "daterange",
                      "value-format": "yyyy-MM-dd",
                      "range-separator": "至",
                      "start-placeholder": "开始日期",
                      "end-placeholder": "结束日期",
                    },
                    on: { change: _vm.handleSearch },
                    model: {
                      value: _vm.dateRange,
                      callback: function ($$v) {
                        _vm.dateRange = $$v
                      },
                      expression: "dateRange",
                    },
                  }),
                ],
                1
              ),
              _c(
                "el-form-item",
                [
                  _c(
                    "el-button",
                    {
                      attrs: { type: "primary" },
                      on: { click: _vm.handleSearch },
                    },
                    [_vm._v("查询")]
                  ),
                  _c("el-button", { on: { click: _vm.handleReset } }, [
                    _vm._v("重置"),
                  ]),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c("div", { staticClass: "metrics" }, [
        _c("div", [
          _c("span", [_vm._v("记录总数")]),
          _c("strong", [_vm._v(_vm._s(_vm.tableData.total))]),
          _c("small", [_vm._v("JOURNAL")]),
        ]),
        _c("div", { staticClass: "success" }, [
          _c("span", [_vm._v("当前页已发布")]),
          _c("strong", [_vm._v(_vm._s(_vm.publishedCount))]),
          _c("small", [_vm._v("PUBLISHED")]),
        ]),
        _c("div", { staticClass: "warning" }, [
          _c("span", [_vm._v("当前页草稿")]),
          _c("strong", [_vm._v(_vm._s(_vm.draftCount))]),
          _c("small", [_vm._v("DRAFT")]),
        ]),
        _c("div", { class: _vm.hiddenCount ? "danger" : "" }, [
          _c("span", [_vm._v("当前页已屏蔽")]),
          _c("strong", [_vm._v(_vm._s(_vm.hiddenCount))]),
          _c("small", [_vm._v("HIDDEN")]),
        ]),
        _c("div", { staticClass: "interaction" }, [
          _c("span", [_vm._v("当前页互动")]),
          _c("strong", [_vm._v(_vm._s(_vm.interactionCount))]),
          _c("small", [_vm._v("COMMENTS")]),
        ]),
      ]),
      _c(
        "el-card",
        {
          staticClass: "table-card",
          attrs: { shadow: "never", "body-style": { padding: "0 20px 20px" } },
        },
        [
          _c(
            "div",
            { staticClass: "title-row" },
            [
              _c("div", [
                _c("strong", [_vm._v("工地过程记录台账")]),
                _c("span", [_vm._v("点击记录查看现场信息、图片和评论回复")]),
              ]),
              _c(
                "el-button",
                {
                  attrs: { size: "mini", icon: "el-icon-refresh" },
                  on: { click: _vm.getList },
                },
                [_vm._v("刷新")]
              ),
            ],
            1
          ),
          _c(
            "el-table",
            {
              directives: [
                {
                  name: "loading",
                  rawName: "v-loading",
                  value: _vm.loading,
                  expression: "loading",
                },
              ],
              attrs: {
                data: _vm.tableData.data,
                size: "mini",
                "highlight-current-row": "",
              },
              on: { "row-click": _vm.openDetail },
            },
            [
              _c("el-table-column", {
                attrs: { label: "汇报时间 / 人员", "min-width": "165" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (ref) {
                      var row = ref.row
                      return [
                        _c("div", { staticClass: "two-line" }, [
                          _c("strong", [_vm._v(_vm._s(row.report.reportTime))]),
                          _c("span", [
                            _vm._v(
                              _vm._s(row.report.reporterName) +
                                " · " +
                                _vm._s(_vm.roleText(row.report.reporterRole))
                            ),
                          ]),
                        ]),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: { label: "类型 / 标题", "min-width": "215" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (ref) {
                      var row = ref.row
                      return [
                        _c(
                          "div",
                          { staticClass: "two-line" },
                          [
                            _c(
                              "el-tag",
                              {
                                attrs: {
                                  size: "mini",
                                  type:
                                    _vm.typeTag[row.report.reportType] ||
                                    "info",
                                },
                              },
                              [
                                _vm._v(
                                  _vm._s(_vm.typeText(row.report.reportType))
                                ),
                              ]
                            ),
                            _c("strong", [_vm._v(_vm._s(row.report.title))]),
                          ],
                          1
                        ),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: { label: "工地项目", "min-width": "190" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (ref) {
                      var row = ref.row
                      return [
                        _c("div", { staticClass: "two-line" }, [
                          _c("strong", [
                            _vm._v(_vm._s(row.project.projectName)),
                          ]),
                          _c("span", [
                            _vm._v(
                              _vm._s(row.property.communityName) +
                                " · " +
                                _vm._s(row.customer.name)
                            ),
                          ]),
                        ]),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: { label: "施工节点", "min-width": "120" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (ref) {
                      var row = ref.row
                      return [
                        _c("div", { staticClass: "two-line" }, [
                          _c("strong", [
                            _vm._v(_vm._s(row.report.scheduleName || "未关联")),
                          ]),
                          row.report.progressPercent !== null
                            ? _c("span", [
                                _vm._v(
                                  "进度 " +
                                    _vm._s(Number(row.report.progressPercent)) +
                                    "%"
                                ),
                              ])
                            : _vm._e(),
                        ]),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: { label: "现场", width: "125" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (ref) {
                      var row = ref.row
                      return [
                        _c("div", { staticClass: "site-cell" }, [
                          _c("span", [
                            _vm._v(_vm._s(row.report.weather || "天气 --")),
                          ]),
                          _c("span", [
                            _vm._v(
                              _vm._s(
                                row.report.workerCount === null
                                  ? "人数 --"
                                  : row.report.workerCount + " 人"
                              )
                            ),
                          ]),
                          _c(
                            "i",
                            { class: row.report.longitude ? "located" : "" },
                            [_vm._v("定位")]
                          ),
                        ]),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: { label: "可见范围", width: "95", align: "center" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (ref) {
                      var row = ref.row
                      return [
                        _vm._v(
                          _vm._s(_vm.visibilityText(row.report.visibility))
                        ),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: { label: "图片 / 互动", width: "105", align: "center" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (ref) {
                      var row = ref.row
                      return [
                        _vm._v(
                          _vm._s((row.report.mediaList || []).length) +
                            " / " +
                            _vm._s(row.report.commentCount || 0)
                        ),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: { label: "状态", width: "95", align: "center" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (ref) {
                      var row = ref.row
                      return [
                        _c(
                          "el-tag",
                          {
                            attrs: {
                              size: "mini",
                              type: _vm.statusTag[row.report.status],
                            },
                          },
                          [_vm._v(_vm._s(_vm.statusText(row.report.status)))]
                        ),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: {
                  label: "操作",
                  width: "150",
                  fixed: "right",
                  align: "center",
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (ref) {
                      var row = ref.row
                      return [
                        _c(
                          "el-button",
                          {
                            attrs: { type: "text", size: "mini" },
                            on: {
                              click: function ($event) {
                                $event.stopPropagation()
                                return _vm.openDetail(row)
                              },
                            },
                          },
                          [_vm._v("查看")]
                        ),
                        row.report.status === "published"
                          ? _c(
                              "el-button",
                              {
                                staticClass: "danger-text",
                                attrs: { type: "text", size: "mini" },
                                on: {
                                  click: function ($event) {
                                    $event.stopPropagation()
                                    return _vm.confirmAction(row, "hide")
                                  },
                                },
                              },
                              [_vm._v("屏蔽")]
                            )
                          : _vm._e(),
                        row.report.status === "hidden"
                          ? _c(
                              "el-button",
                              {
                                attrs: { type: "text", size: "mini" },
                                on: {
                                  click: function ($event) {
                                    $event.stopPropagation()
                                    return _vm.confirmAction(row, "restore")
                                  },
                                },
                              },
                              [_vm._v("恢复")]
                            )
                          : _vm._e(),
                      ]
                    },
                  },
                ]),
              }),
            ],
            1
          ),
          _c(
            "div",
            { staticClass: "block" },
            [
              _c("el-pagination", {
                attrs: {
                  background: "",
                  "page-sizes": _vm.$constants.page.limit,
                  "page-size": _vm.searchForm.limit,
                  "current-page": _vm.searchForm.page,
                  layout: "total, sizes, prev, pager, next, jumper",
                  total: _vm.tableData.total,
                },
                on: {
                  "size-change": _vm.handleSizeChange,
                  "current-change": _vm.handleCurrentChange,
                },
              }),
            ],
            1
          ),
        ],
        1
      ),
      _vm.detail
        ? _c(
            "el-drawer",
            {
              attrs: {
                visible: _vm.drawerVisible,
                size: "620px",
                "custom-class": "report-drawer",
                "with-header": false,
              },
              on: {
                "update:visible": function ($event) {
                  _vm.drawerVisible = $event
                },
              },
            },
            [
              _c(
                "div",
                { staticClass: "drawer-head" },
                [
                  _c("div", [
                    _c("span", [
                      _vm._v(
                        _vm._s(_vm.typeText(_vm.detail.report.reportType)) +
                          " · " +
                          _vm._s(_vm.detail.report.reportTime)
                      ),
                    ]),
                    _c("h3", [_vm._v(_vm._s(_vm.detail.report.title))]),
                    _c("p", [
                      _vm._v(
                        _vm._s(_vm.detail.project.projectName) +
                          " · " +
                          _vm._s(_vm.detail.report.reporterName) +
                          "（" +
                          _vm._s(_vm.roleText(_vm.detail.report.reporterRole)) +
                          "）"
                      ),
                    ]),
                  ]),
                  _c(
                    "el-tag",
                    {
                      attrs: { type: _vm.statusTag[_vm.detail.report.status] },
                    },
                    [_vm._v(_vm._s(_vm.statusText(_vm.detail.report.status)))]
                  ),
                ],
                1
              ),
              _c("div", { staticClass: "drawer-body" }, [
                _c("div", { staticClass: "detail-grid" }, [
                  _c("div", [
                    _c("span", [_vm._v("工地客户")]),
                    _c("strong", [_vm._v(_vm._s(_vm.detail.customer.name))]),
                  ]),
                  _c("div", [
                    _c("span", [_vm._v("可见范围")]),
                    _c("strong", [
                      _vm._v(
                        _vm._s(_vm.visibilityText(_vm.detail.report.visibility))
                      ),
                    ]),
                  ]),
                  _c("div", [
                    _c("span", [_vm._v("施工节点")]),
                    _c("strong", [
                      _vm._v(
                        _vm._s(_vm.detail.report.scheduleName || "未关联")
                      ),
                    ]),
                  ]),
                  _c("div", [
                    _c("span", [_vm._v("节点进度")]),
                    _c("strong", [
                      _vm._v(
                        _vm._s(
                          _vm.detail.report.progressPercent === null
                            ? "--"
                            : Number(_vm.detail.report.progressPercent) + "%"
                        )
                      ),
                    ]),
                  ]),
                  _c("div", [
                    _c("span", [_vm._v("天气 / 人数")]),
                    _c("strong", [
                      _vm._v(
                        _vm._s(_vm.detail.report.weather || "--") +
                          " / " +
                          _vm._s(
                            _vm.detail.report.workerCount === null
                              ? "--"
                              : _vm.detail.report.workerCount + " 人"
                          )
                      ),
                    ]),
                  ]),
                  _c("div", [
                    _c("span", [_vm._v("现场定位")]),
                    _c("strong", [
                      _vm._v(
                        _vm._s(
                          _vm.detail.report.longitude
                            ? _vm.detail.report.longitude +
                                ", " +
                                _vm.detail.report.latitude
                            : "未记录"
                        )
                      ),
                    ]),
                  ]),
                ]),
                _c("div", { staticClass: "content-block" }, [
                  _c("span", [_vm._v("现场记录")]),
                  _c("p", [_vm._v(_vm._s(_vm.detail.report.content))]),
                ]),
                _vm.detail.report.mediaList &&
                _vm.detail.report.mediaList.length
                  ? _c(
                      "div",
                      { staticClass: "media-list" },
                      _vm._l(
                        _vm.detail.report.mediaList,
                        function (url, index) {
                          return _c("el-image", {
                            key: url,
                            attrs: {
                              src: url,
                              "preview-src-list": _vm.detail.report.mediaList,
                              "initial-index": index,
                              fit: "cover",
                            },
                          })
                        }
                      ),
                      1
                    )
                  : _vm._e(),
                _c("div", { staticClass: "comment-title" }, [
                  _c("strong", [_vm._v("项目互动")]),
                  _c("span", [
                    _vm._v(
                      _vm._s(_vm.detail.report.commentCount || 0) +
                        " 条评论 / 回复"
                    ),
                  ]),
                ]),
                _vm.detail.report.interactions &&
                _vm.detail.report.interactions.length
                  ? _c(
                      "div",
                      { staticClass: "comments" },
                      _vm._l(_vm.detail.report.interactions, function (item) {
                        return _c(
                          "div",
                          {
                            key: item.id,
                            class: ["comment", item.parentId ? "reply" : ""],
                          },
                          [
                            _c("div", [
                              _c("strong", [_vm._v(_vm._s(item.actorName))]),
                              _c("span", [
                                _vm._v(
                                  _vm._s(_vm.roleText(item.actorRole)) +
                                    " · " +
                                    _vm._s(item.time)
                                ),
                              ]),
                            ]),
                            _c("p", [
                              _vm._v(
                                _vm._s(item.parentId ? "回复：" : "") +
                                  _vm._s(item.content)
                              ),
                            ]),
                            item.mentionedMemberIds &&
                            item.mentionedMemberIds.length
                              ? _c("small", [
                                  _vm._v(
                                    "提醒了 " +
                                      _vm._s(item.mentionedMemberIds.length) +
                                      " 位项目成员"
                                  ),
                                ])
                              : _vm._e(),
                          ]
                        )
                      }),
                      0
                    )
                  : _c("div", { staticClass: "no-comments" }, [
                      _vm._v("暂无互动记录"),
                    ]),
                _vm.detail.report.status === "published"
                  ? _c(
                      "div",
                      { staticClass: "comment-form" },
                      [
                        _c("el-input", {
                          attrs: {
                            type: "textarea",
                            rows: 3,
                            maxlength: "1000",
                            "show-word-limit": "",
                            placeholder:
                              "以商户管理员身份评论，内容将同步到项目成员端",
                          },
                          model: {
                            value: _vm.commentContent,
                            callback: function ($$v) {
                              _vm.commentContent =
                                typeof $$v === "string" ? $$v.trim() : $$v
                            },
                            expression: "commentContent",
                          },
                        }),
                        _c(
                          "el-button",
                          {
                            attrs: { type: "primary", loading: _vm.commenting },
                            on: { click: _vm.sendComment },
                          },
                          [_vm._v("发送后台评论")]
                        ),
                      ],
                      1
                    )
                  : _vm._e(),
              ]),
              _c(
                "div",
                { staticClass: "drawer-actions" },
                [
                  _c(
                    "el-button",
                    {
                      on: {
                        click: function ($event) {
                          _vm.drawerVisible = false
                        },
                      },
                    },
                    [_vm._v("关闭")]
                  ),
                  _vm.detail.report.status === "published"
                    ? _c(
                        "el-button",
                        {
                          attrs: { type: "danger", plain: "" },
                          on: {
                            click: function ($event) {
                              return _vm.confirmAction(_vm.detail, "hide")
                            },
                          },
                        },
                        [_vm._v("屏蔽内容")]
                      )
                    : _vm._e(),
                  _vm.detail.report.status === "hidden"
                    ? _c(
                        "el-button",
                        {
                          attrs: { type: "success" },
                          on: {
                            click: function ($event) {
                              return _vm.confirmAction(_vm.detail, "restore")
                            },
                          },
                        },
                        [_vm._v("恢复展示")]
                      )
                    : _vm._e(),
                  _c(
                    "el-button",
                    {
                      attrs: { type: "danger", plain: "" },
                      on: {
                        click: function ($event) {
                          return _vm.confirmAction(_vm.detail, "delete")
                        },
                      },
                    },
                    [_vm._v("删除记录")]
                  ),
                ],
                1
              ),
            ]
          )
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "hero" }, [
      _c("div", [
        _c("span", [_vm._v("PROJECT JOURNAL & SITE REPORT")]),
        _c("h2", [_vm._v("工地日记与施工汇报")]),
        _c("p", [
          _vm._v(
            "统一追踪日常、进度、质量、安全、巡检、主材、验收和服务记录，沉淀现场互动留痕。"
          ),
        ]),
      ]),
      _c("div", { staticClass: "hero-badges" }, [
        _c("b", [_vm._v("过程留痕")]),
        _c("b", [_vm._v("互动协同")]),
        _c("b", [_vm._v("内容治理")]),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }